import { useEffect } from "react";
import { SigROn } from "@/types/signalr-functions.ts";
import { JsonParse } from "@/helpers/json.ts";
import type { AssignedChatDetails } from "@/types/assignedChatDetails.ts";
import { log } from "@/helpers/console.ts";
import { useUserStore } from "@/stores/useUserStore.ts";
import { useAssignedChatStore } from "@/stores/useAssignedChatStore.ts";
import { useChatStore } from "@/stores/useChatStore.ts";
import { useInputStore } from "@/stores/useInputStore.ts";
import { useSignalStore } from "@/stores/useSignalrStore.ts";
import { None, type Option } from "ts-results-es";

export const useHookNewChat = () => {
  const { AddNewSession, RemoveSession } = useAssignedChatStore();
  const { AddNewChat, RemoveChat, SoftResetChat } = useChatStore();
  const { RemoveSessionData } = useInputStore();

  const { signalr } = useSignalStore();

  useEffect(() => {
    let removeHook: Option<() => void> = None;
    // Note: For now, always listen if the browser is active
    // If we're being sent a tutor assigned, we should listen no matter what
    if (signalr /*&& settings.groupJoined*/) {
      removeHook = signalr.On(SigROn.TutorAssigned, (data: string) => {
        const parsedData = JsonParse<AssignedChatDetails>(data);
        log("New session assign attempt", parsedData, data);

        const { userId, tutorId } = useUserStore.getState();

        if (!parsedData) return;

        const assignedToMe = parsedData.tutorUserId
          ? parsedData.tutorUserId === userId
          : parsedData.tutorId === tutorId;

        if (!assignedToMe) {
          return;
        }

        const { assignedSessions: activeSessions } = useAssignedChatStore.getState();

        const alreadyAssigned = activeSessions.get(parsedData.flowGeneratorSessionId);

        if (!alreadyAssigned) {
          AddNewSession({
            assignedChat: parsedData,
          });
          AddNewChat({
            flowGeneratorSessionId: parsedData.flowGeneratorSessionId,
          });
        } else if (alreadyAssigned.completed) {
          RemoveSession(alreadyAssigned.assignedChat.flowGeneratorSessionId);
          RemoveSessionData(alreadyAssigned.assignedChat.flowGeneratorSessionId);
          AddNewSession({
            assignedChat: parsedData,
          });
          AddNewChat({
            flowGeneratorSessionId: parsedData.flowGeneratorSessionId,
          });
          // SoftResetChat(alreadyAssigned.assignedChat.flowGeneratorSessionId);/

          // RemoveChat(alreadyAssigned.assignedChat.flowGeneratorSessionId);
          // AddSession();
        }
      });
    }

    return () => {
      if (removeHook.isSome()) removeHook.unwrap()();
    };
  }, [
    AddNewChat,
    AddNewSession,
    RemoveChat,
    RemoveSessionData,
    SoftResetChat,
    RemoveSession,
    signalr,
  ]);
};
